var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({style:(_vm.style),attrs:{"rounded-lg":"","outlined":"","single-line":"","dense":"","label":"Pesquisar","autofocus":"","clearable":"","hide-details":"","prepend-inner-icon":"mdi-magnify"},on:{"focus":_vm.onFocus}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }